module.exports = __webpack_public_path__ + "static/fictionGif-4afb6d762b6158e7e971f23dc773e852.mp4";